export default function HeroBanner() {
    return (
        <div className="container mx-auto my-16">
            <div className="md:space-y-0 md:space-x-4 flex items-center space-y-5 px-10 pt-5">
                <div className="md:w-2/4 md:text-left text-center">
                    <p className="md:text-[22px] text-[20px] olm-gradient-text font-semibold leading-7 inline-block">
                        About Us
                    </p>

                    <h1 className="text-[50px] leading-[58px] text-3xl font-bold">
                        <span>Open Letter</span>
                        <br />
                        <span>Marketing</span>
                    </h1>
                    <br />
                    <div className="md:w-2/4 md:hidden h-full">
                        <img
                            src="/assets/about-us/hero-banner-mobile.webp"
                            alt="about us"
                        />
                    </div>
                    <br className="md:hidden" />
                    <p className="text-lg text-[#444241] md:mr-[2.75rem]">
                        Welcome to Open Letter Marketing, where our journey
                        intertwines with the dreams of real estate investors and
                        their quest for success. I&apos;m the founder, and my
                        story began back in 2010, fueled by a vision to redefine
                        the landscape of real estate investing.
                    </p>
                    <br />
                    <h4 className="text-lg font-extrabold olm-gradient-text leading-[24px] inline-block">
                        Justin Silverio
                    </h4>
                    <p className="text-lg font-normal leading-6">
                        CEO & Founder
                    </p>
                </div>
                <div className="md:w-2/4 md:block h-full hidden">
                    <img
                        src="/assets/about-us/hero-banner.webp"
                        alt="Justin with OLM team in a round shape graphic"
                        title="Justin & OLM Team"
                    />
                </div>
            </div>
        </div>
    )
}
